import React from 'react';

import { Button, Form, Input } from 'semantic-ui-react';

import { shouldFieldBeRed, isFormValid } from "../../helpers";


const ForgotPasswordForm = (props) => {
    const { onResetPassword, onReturn, handleChange } = props;
    const { username } = props.form;

    return (
        <Form onSubmit={onResetPassword}>
            <Form.Field error={shouldFieldBeRed(username)}>
                <Input
                    id="username"
                    icon="user"
                    placeholder='E-mail'
                    name="username"
                    type="email"
                    value={username.value}
                    onChange={handleChange} />
            </Form.Field>
            <Button circular icon="arrow left" onClick={onReturn} />
            <Button type="submit" positive floated="right" disabled={!isFormValid(props.form)}>Envoyer</Button>
        </Form>
    );

};

export default ForgotPasswordForm;


// WEBPACK FOOTER //
// ./src/components/Authentication/ForgotPasswordForm.js